<app-storage-quantity-number-input
    [model]="formControl?.value"
    [productSig]="documentLineItem()?.product"
    [minFractionDigits]="minFractionDigits()"
    [maxFractionDigits]="maxFractionDigits()"
    [upDownButtons]="upDownButtons() ?? props.upDownButtons"
    [quantityStep]="quantityStep()"
    [formlyAttributes]="field"
    [formControl]="formControl"
    (valueChange)="valueChanged($event)"
    #input
></app-storage-quantity-number-input>
